import { jsxs, jsx } from "react/jsx-runtime";
import { Form } from "./Form.js";
import { Textarea } from "./Textarea.js";
import { useId } from "./useId.js";
function TextareaField({
  label,
  labelSecondaryText,
  helperText,
  helperTextIcon,
  // Common props
  id,
  isInvalid,
  // Textarea props
  isDisabled,
  isReadOnly,
  maxLength,
  maxRows,
  minRows,
  onBlur,
  onChange,
  onFocus,
  placeholder,
  value,
  autoFocus,
  TextareaRef,
  ...props
}) {
  const uniqueId = useId("input");
  const textareaId = id || uniqueId;
  const helperTextId = useId("helper-text");
  return /* @__PURE__ */ jsxs(Form.Group, {
    ...props,
    children: [/* @__PURE__ */ jsx(Form.Label, {
      secondaryText: labelSecondaryText,
      htmlFor: textareaId,
      children: label
    }), /* @__PURE__ */ jsx(Textarea, {
      isDisabled,
      isReadOnly,
      isInvalid,
      maxLength,
      maxRows,
      minRows,
      onBlur,
      onChange,
      onFocus,
      placeholder,
      value,
      id: textareaId,
      "aria-describedby": helperText ? helperTextId : void 0,
      autoFocus,
      ref: TextareaRef
    }), helperText ? /* @__PURE__ */ jsx(Form.HelperText, {
      icon: helperTextIcon,
      isInvalid,
      id: helperTextId,
      children: helperText
    }) : null]
  });
}
export {
  TextareaField
};
//# sourceMappingURL=TextareaField.js.map
